(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-collapsible-tabs"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      if (!details.classList.contains('collapsible-tab')) return;

      var wrapper = details.closest('.collapsible-tabs[data-exclusive]');
      if (!wrapper) return;

      wrapper.querySelectorAll('details.collapsible-tab[open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
